import {
    AppRemoveButtonPopup,
    FlexBox,
    AppTable,
    FlexRow,
    AppEditButton,
} from 'components'
import React, { useMemo } from 'react'
import { useTabletAndBelowMediaQuery } from 'layout'
import { Card } from 'semantic-ui-react'

const ActionBoxes = ({ onEdit, onRemove }) => (
    <>
        <AppEditButton onClick={onEdit} type="button" />
        <AppRemoveButtonPopup onConfirm={onRemove} />
    </>
)

const AssetTypeCard = ({ item, onEdit, onRemove }) => (
    <Card fluid>
        <Card.Content>
            <Card.Header>{item.type}</Card.Header>
            <Card.Description>
                <FlexRow>
                    <Card.Meta>Description:</Card.Meta>&nbsp; {item.description || 'Description'}
                </FlexRow>
                <FlexBox className="justify-content-end mt-2">
                    <ActionBoxes
                        onEdit={() => onEdit(item)}
                        onRemove={() => onRemove(item.id)}
                    />
                </FlexBox>
            </Card.Description>
        </Card.Content>
    </Card>
)

export const AssetTypeList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    onEdit,
    onRemove,
}) => {
    const isMobile = useTabletAndBelowMediaQuery()

    const columns = useMemo(
        () => [
            {
                title: 'Type',
                key: 'type',
                textAlign: 'left',
            },
            {
                title: 'Description',
                key: 'description',
                textAlign: 'left',
                render: item => item.description || 'Description',
            },
            {
                title: 'Actions',
                key: 'actions',
                textAlign: 'center',
                width: isMobile ? 'auto' : 150,
                render: item => (
                    <FlexBox className="justify-content-center">
                        <ActionBoxes
                            onEdit={() => onEdit(item)}
                            onRemove={() => onRemove(item.id)}
                        />
                    </FlexBox>
                ),
            },
        ],
        [isMobile, onEdit, onRemove],
    )

    return (
        <AppTable
            data={data}
            columns={columns}
            pageChanged={pageChanged}
            filter={filter}
            totalCount={totalCount}
            mobileCard={<AssetTypeCard onEdit={onEdit} onRemove={onRemove} />}
        />
    )
}
